import { render, staticRenderFns } from "./OrderSummaryHeader.vue?vue&type=template&id=bb70a15e&scoped=true&"
import script from "./OrderSummaryHeader.vue?vue&type=script&lang=js&"
export * from "./OrderSummaryHeader.vue?vue&type=script&lang=js&"
import style0 from "./OrderSummaryHeader.vue?vue&type=style&index=0&id=bb70a15e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb70a15e",
  null
  
)

export default component.exports